/*! @pentacode/ui v0.1.0 */
import "../form-elements/select.js";
import "../form-elements/text-input.js";
import { t as e } from "../../styledElement-DUAqv8gi.js";
import "../../bank-details-section-BMiISEOQ.js";
import "./shared/current-status-section.js";
import "./shared/disability-section.js";
import "./shared/education-section.js";
import "./shared/general-section.js";
import "./shared/health-insurance-section.js";
import { t } from "../../decorateMetadata-BXz2gmG4.js";
import { t as n } from "../../decorate-C_HUHFGG.js";
import { LitElement as r, html as i } from "lit";
import { customElement as a, property as o, state as s } from "lit/decorators.js";
// src/elements/employee-questionnaire/marginal-employment-form.ts
var c = class extends e(r) {
	constructor(...e) {
		super(...e), this.employeeId = 0, this._general = { mainJob: !1 }, this._bankDetails = { payByBankTransfer: !0 }, this._currentStatus = {
			immatriculationStatus: !1,
			registeredAsJobSeeker: !1,
			receivingAgencyBenefits: !1
		}, this._education = {}, this._healthInsurance = {}, this._disability = { disabilityLevel: !1 };
	}
	willUpdate(e) {
		e.has("payrollData") && this.payrollData && this._initializeFromPayrollData(this.payrollData);
	}
	_initializeFromPayrollData(e) {
		this._general = {
			occupation: e.occupation,
			passportNumber: e.passportNumber,
			mainJob: e.mainJob ?? !1,
			pvBonusChildren: e.pvBonusChildren,
			taxClass: e.taxClass,
			taxClass4Factor: e.taxClass4Factor ? parseFloat(e.taxClass4Factor) : void 0,
			childrenFreeAmount: e.childrenFreeAmount,
			confession: e.confession
		}, this._bankDetails = {
			payByBankTransfer: e.bankDetails?.payByBankTransfer ?? !0,
			bankAccountOwner: e.bankDetails?.bankAccountOwner,
			iban: e.bankDetails?.iban,
			bankName: e.bankDetails?.bankName
		}, this._currentStatus = {
			immatriculationStatus: e.currentStatus?.immatriculationStatus ?? !1,
			registeredAsJobSeeker: e.currentStatus?.registeredAsJobSeeker ?? !1,
			receivingAgencyBenefits: e.currentStatus?.receivingAgencyBenefits ?? !1
		}, this._education = {
			schoolEducation: e.education?.schoolEducation,
			professionalEducation: e.education?.professionalEducation
		}, this._healthInsurance = {
			ensuranceType: e.healthInsuranceStatus?.ensuranceType,
			otherEnsuranceType: e.healthInsuranceStatus?.otherEnsuranceType,
			lastEnsurance: e.healthInsuranceStatus?.lastEnsurance,
			ensurerName: e.healthInsuranceStatus?.ensurerName
		}, this._disability = {
			disabilityLevel: e.disabilityInfo?.disabilityLevel ?? !1,
			disabilityLevelPercentage: e.disabilityInfo?.disabilityLevelPercentage
		};
	}
	render() {
		return i`
            <style>
                ptc-ui-select,
                ptc-ui-text-input {
                    display: block;
                    width: 100%;
                }
            </style>
            <div class="mx-auto max-w-4xl p-4">
                <h1 class="mb-8 text-2xl font-semibold text-gray-800">Fragebogen zur Beschäftigung</h1>

                <form @submit=${this._handleSubmit}>
                    <!-- General Section (Tax Info) -->
                    <div class="mb-8 rounded-lg bg-white p-6 shadow-sm">
                        <ptc-ui-employee-questionnaire-general-section
                            .data=${this._general}
                            @change=${(e) => {
			e.stopPropagation(), this._general = e.detail;
		}}
                        ></ptc-ui-employee-questionnaire-general-section>
                    </div>

                    <!-- Bank Details Section -->
                    <div class="mb-8 rounded-lg bg-white p-6 shadow-sm">
                        <ptc-ui-employee-questionnaire-bank-details-section
                            .data=${this._bankDetails}
                            @change=${(e) => {
			e.stopPropagation(), this._bankDetails = e.detail;
		}}
                        ></ptc-ui-employee-questionnaire-bank-details-section>
                    </div>

                    <!-- Current Status Section -->
                    <div class="mb-8 rounded-lg bg-white p-6 shadow-sm">
                        <ptc-ui-employee-questionnaire-current-status-section
                            .data=${this._currentStatus}
                            @change=${(e) => {
			e.stopPropagation(), this._currentStatus = e.detail;
		}}
                        ></ptc-ui-employee-questionnaire-current-status-section>
                    </div>

                    <!-- @TODO: Add additional employment information section -->

                    <!-- Education Section -->
                    <div class="mb-8 rounded-lg bg-white p-6 shadow-sm">
                        <ptc-ui-employee-questionnaire-education-section
                            .data=${this._education}
                            @change=${(e) => {
			e.stopPropagation(), this._education = e.detail;
		}}
                        ></ptc-ui-employee-questionnaire-education-section>
                    </div>

                    <!-- Health Insurance Section -->
                    <div class="mb-8 rounded-lg bg-white p-6 shadow-sm">
                        <ptc-ui-employee-questionnaire-health-insurance-section
                            .data=${this._healthInsurance}
                            @change=${(e) => {
			e.stopPropagation(), this._healthInsurance = e.detail;
		}}
                        ></ptc-ui-employee-questionnaire-health-insurance-section>
                    </div>

                    <!-- Disability Section -->
                    <div class="mb-8 rounded-lg bg-white p-6 shadow-sm">
                        <ptc-ui-employee-questionnaire-disability-section
                            .data=${this._disability}
                            @change=${(e) => {
			e.stopPropagation(), this._disability = e.detail;
		}}
                        ></ptc-ui-employee-questionnaire-disability-section>
                    </div>

                    <div class="flex justify-end gap-3">
                        <button
                            type="button"
                            class="rounded-lg border border-gray-300 bg-white px-6 py-2.5 font-medium text-gray-700 shadow-sm transition-all hover:bg-gray-50 focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 focus:outline-none"
                            @click=${this._handleCancel}
                        >
                            Abbrechen
                        </button>
                        <button
                            type="submit"
                            class="rounded-lg bg-blue-600 px-6 py-2.5 font-medium text-white shadow-sm transition-all hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none"
                        >
                            Speichern
                        </button>
                    </div>
                </form>
            </div>
        `;
	}
	_handleSubmit(e) {
		e.preventDefault();
		let t = {
			employeeId: this.employeeId,
			occupation: this._general.occupation,
			passportNumber: this._general.passportNumber,
			mainJob: this._general.mainJob,
			pvBonusChildren: this._general.pvBonusChildren,
			taxClass: this._general.taxClass,
			taxClass4Factor: this._general.taxClass4Factor?.toString(),
			childrenFreeAmount: this._general.childrenFreeAmount,
			confession: this._general.confession,
			bankDetails: this._bankDetails,
			currentStatus: this._currentStatus,
			education: this._education,
			healthInsuranceStatus: this._healthInsurance,
			disabilityInfo: this._disability
		};
		this.dispatchEvent(new CustomEvent("form-submit", {
			detail: t,
			bubbles: !0,
			composed: !0
		}));
	}
	_handleCancel() {
		this.dispatchEvent(new CustomEvent("form-cancel", {
			bubbles: !0,
			composed: !0
		}));
	}
};
n([o({ type: Number }), t("design:type", Number)], c.prototype, "employeeId", void 0), n([o({ type: Object }), t("design:type", Object)], c.prototype, "payrollData", void 0), n([s(), t("design:type", Object)], c.prototype, "_general", void 0), n([s(), t("design:type", Object)], c.prototype, "_bankDetails", void 0), n([s(), t("design:type", Object)], c.prototype, "_currentStatus", void 0), n([s(), t("design:type", Object)], c.prototype, "_education", void 0), n([s(), t("design:type", Object)], c.prototype, "_healthInsurance", void 0), n([s(), t("design:type", Object)], c.prototype, "_disability", void 0), c = n([a("ptc-ui-marginal-employment-form")], c);
export { c as MarginalEmploymentForm };

//# sourceMappingURL=marginal-employment-form.js.map